"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.closeButtonZIndex = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../../components/breakpoints"));
var _index = require("../../components/CopyBlock/index.styled");
const closeButtonZIndex = exports.closeButtonZIndex = 5;
var _default = exports.default = {
  SubpageOverlayContainer: _styledComponents.default.div`
    ${function (_ref) {
    let {
      editMode,
      $isSamePageOverlay,
      $topPosition
    } = _ref;
    return editMode ? `position: relative;
      opacity: 1;
      z-index: 0;
      top: 0;
      ` : `position:fixed;
    z-index: -100;
    opacity: 0;
    ${$isSamePageOverlay ? `top:${$topPosition}px;` : `top:0;
      height:100%;`}`;
  }}
    transform: scale3d(1,1,1);
    left: 0;
    width: 100%;
    transition: opacity 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    ${function (_ref2) {
    let {
      $isShowingPage,
      $layer
    } = _ref2;
    return $isShowingPage ? (0, _styledComponents.css)`
      opacity: 1;
      z-index: ${9999 + ($layer !== null && $layer !== void 0 ? $layer : 0)};
    ` : `
      visibility: hidden;
    `;
  }}
  `,
  SubpageOverlayBackground: _styledComponents.default.button`
  ${function (_ref3) {
    let {
      $isSamePageOverlay
    } = _ref3;
    return $isSamePageOverlay ? `
    height: 200vh;` : `height: 100%;
    top:0;
    `;
  }}
    text-indent: -9999px;
    display: block;
    ${function (_ref4) {
    let {
      $overlayBackground
    } = _ref4;
    return $overlayBackground ? `background: ${$overlayBackground};` : "background: rgba(0, 0, 0, 0.4);";
  }}
    position: absolute;
    width: 100%;
    left: 0;
    padding: 0;
    margin: 0;
    border: none;
  `,
  SubpageOverlay: _styledComponents.default.div`
    display: flex;
    position: relative;
    background: ${function (_ref5) {
    let {
      $background
    } = _ref5;
    return $background === "useTheme" ? "var(--app-background-color, #FFF)" : $background;
  }};
    color: ${function (_ref6) {
    let {
      $color
    } = _ref6;
    return $color === "useTheme" ? "var(--app-primary-text-color, #000)" : $color;
  }};
    transform: scale3d(1, 1, 1);
    iframe {
      min-height: 50vh;
    }
    ${function (_ref7) {
    let {
      $fit
    } = _ref7;
    return $fit !== "child" ? `
      width: 100%;
      height: 100%;
    ` : `
      max-height: 90%;
      ${(0, _breakpoints.default)("mobile")} {
        width: 90%;
      }
    `;
  }}

    ${function (_ref8) {
    let {
      $isSamePageOverlay,
      $isDeepLink
    } = _ref8;
    return $isSamePageOverlay && `
    ${$isDeepLink ? "margin: 100px 50px 0 50px;" : "margin: 0 50px 0 50px; "}
      ${(0, _breakpoints.default)("mobile")} {
        margin: 0 15px 0 15px;
      }
    `;
  }}

    ${function (_ref9) {
    let {
      $fit
    } = _ref9;
    return $fit === "lightbox" && `
      max-width: 620px;
      width: calc(100% - 50px);
      max-height: 80%;
      height: auto;
    `;
  }}

    ${function (_ref10) {
    let {
      $width
    } = _ref10;
    return $width && `
      max-width: ${$width};
    `;
  }}

    ${function (_ref11) {
    let {
      $height
    } = _ref11;
    return $height && `
      height: ${$height};
    `;
  }}

    ${function (_ref12) {
    let {
      $maxHeight
    } = _ref12;
    return $maxHeight && `
      max-height: ${$maxHeight};
    `;
  }}

    ${function (_ref13) {
    let {
      $borderRadius
    } = _ref13;
    return $borderRadius && `
      border-radius: ${$borderRadius};
    `;
  }}
  `,
  PageContent: _styledComponents.default.div`
    width: 100%;
    position: relative;
    overflow: hidden;
    ${function (_ref14) {
    let {
      $isIframe
    } = _ref14;
    return !$isIframe && "overflow-y: auto;";
  }}
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    ${function (_ref15) {
    let {
      $pageSpacing
    } = _ref15;
    return $pageSpacing && "padding-top: 65px;";
  }}
    ${function (_ref16) {
    let {
      $isScrollable
    } = _ref16;
    return !$isScrollable && "overflow: hidden;";
  }}
    ${function (_ref17) {
    let {
      $borderRadius
    } = _ref17;
    return $borderRadius && `border-radius: ${$borderRadius};`;
  }}
    
    /* Auto-detect ContentTabs with sticky headers and disable overlay scrolling */
    &:has([id="ContentTabs"]) {
      overflow: hidden;
    }
  `,
  FocusLock: _styledComponents.default.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  ChildrenWrapper: _styledComponents.default.div`
    height: 100%;
    & > ${_index.CopyBlock}:last-child {
      margin-bottom: 65px;
    }
  `,
  CloseButton: _styledComponents.default.button`
    height: 60px;
    width: 60px;
    cursor: pointer;
    background: rgba(49,49,49,.7);
    border: none;
    position: absolute;
    right: 0;
    top: 0;
    z-index: ${closeButtonZIndex};
    svg {
      width: 20px;
      top: 50%;
      left: 50%;
    }
    ${function (_ref18) {
    let {
      theme
    } = _ref18;
    return theme === "Lexus" && `
      background: ${theme === "light" ? "transparent" : "#000"};
      svg {
        fill: ${theme === "light" ? "#000" : "#fff"};
      }
      opacity: ${theme === "light" ? 0.5 : 1};
    `;
  }}
    ${function (_ref19) {
    let {
      theme
    } = _ref19;
    return theme === "Toyota" && `
      width: 40px;
      height: 40px;
      border: solid 2px #767676;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      right: 32px;
      top: 32px;
      background: transparent;
        svg {
          stroke: #000000;
          stroke-width: 2px;
          transform: scale(0.6);
        }
    `;
  }}
    ${function (_ref20) {
    let {
      theme
    } = _ref20;
    return theme === "dark" && `
      background: #000;
      opacity: 0.5;
    `;
  }}
    ${function (_ref21) {
    let {
      theme
    } = _ref21;
    return theme === "ToyotaSST" && `
    width: 64px;
    height: 40px;
    border: solid 2px #767676;
    display: flex;
    margin-right: 32px;
    margin-top: 32px;
    background: #FFF;
      svg {
        stroke: #000000;
        stroke-width: 2px;
        transform: scale(0.6);
      }

    padding: 12px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 32px;
    `;
  }}
    ${function (_ref22) {
    let {
      theme
    } = _ref22;
    return theme === "ToyotaSSTSmall" && `
    width: 44px;
    height: 24px;
    border: solid 2px #767676;
    display: flex;
    margin-right: 16px;
    margin-top: 16px;
    background: #FFF;
      svg {
        stroke: #000000;
        stroke-width: 2px;
        transform: scale(0.6);
      }

    padding: 12px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 32px;
    `;
  }}
    ${function (_ref23) {
    let {
      theme
    } = _ref23;
    return theme === "ToyotaSSTBlack" && `
    width: 64px;
    height: 40px;
    border: solid 2px #000;
    display: flex;
    margin-right: 32px;
    margin-top: 32px;
    background: #000;
      svg {
        stroke: #FFF;
        stroke-width: 2px;
        transform: scale(0.6);
      }

    padding: 12px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 32px;
    padding: 12px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 32px;
    `;
  }}
    ${function (_ref24) {
    let {
      theme
    } = _ref24;
    return theme === "ToyotaSSTBlackSmall" && `
    width: 44px;
    height: 24px;
    border: solid 2px #000;
    display: flex;
    margin-right: 16px;
    margin-top: 16px;
    background: #000;
      svg {
        stroke: #fff;
        stroke-width: 2px;
        transform: scale(0.6);
      }

    padding: 12px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 32px;
    `;
  }}
${function (_ref25) {
    let {
      theme
    } = _ref25;
    return theme === "LexusTransparent" && `
    background: transparent;
      svg {
        stroke: #000;
      }
    `;
  }}
    
    ${function (_ref26) {
    let {
      $backgroundColor
    } = _ref26;
    return $backgroundColor && `background: ${$backgroundColor} !important;`;
  }}
    ${function (_ref27) {
    let {
      $iconColor
    } = _ref27;
    return $iconColor && `svg { fill: ${$iconColor} !important; }`;
  }}
  `,
  Iframe: _styledComponents.default.iframe`
    width: 100%;
    height: 100%;
    border: none;
  `
};